export class IFeeDetailPrint {
    invoice: string;
    createdDate: Date;
    startDate: Date;
    endDate: Date;
    membershipNumber: string;
    memberName: string;
    feeType: string;
    fee: string;
    tax: string;
    discount: string;
    taxRate: number;
    taxCalculationType: string;
}
